import { DTOConstructor } from "./dto-constructor";

export class PositionDTO extends DTOConstructor<PositionDTO> {
    id: number;
    name: string;
    departmentId: number;
    order: number;
    color: string;
}
